import {Skeleton, TableCell, TableRow} from '@mui/material'

const EmptyTable = ({ cols, rows, height = 'h-14' , isLoading=false }) => {
    return Array.apply(null, Array(rows)).map((key, idx) => (
        <TableRow key={idx}>
            {Array.apply(null, Array(cols)).map((innerKey, innerIdx) => (
                <TableCell key={innerIdx}>
                    {isLoading ? <Skeleton />
                        : <div className={height}></div> }
                </TableCell>
            ))}
        </TableRow>
    ))
}

export default EmptyTable
